import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SharedServices } from 'src/app/shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  userRole: string = ''
  constructor(private sharedServices: SharedServices, private router: Router) {}

  canActivate(): boolean {
    const isAuthenticated = localStorage.getItem('token')
    this.userRole = this.sharedServices.userLogin.rol

    if (!isAuthenticated) {
      this.router.navigate(['/login']); // Redirigir si no está autenticado
      return false;
    }

    if (this.userRole != 'Paciente' && this.userRole != 'EPS' &&  this.userRole != 'Distribuidor' && this.userRole != 'PQRs'
      && this.userRole != 'LAB'  && this.userRole != 'Logistico'
    ) {
      this.router.navigate(['/unauthorized']); // Redirigir si no tiene permiso
      return false;
    }

    return true; // Acceso permitido
  }
}
